import { useLocation, matchPath } from 'react-router-dom';

import { InsuranceTypes, tInsuranceTypeName } from '@models/InsuranceType';
import { useParseParams } from '@hooks/params';
import { routePersonalAccidentQuoteResultPage } from '@components/PersonalAccidentQuoteResultPage';
import { routeCancerQuoteResultPage } from '@components/CancerQuoteResultPage';
import { getAllHealthQuoteParamsSchema } from '@apis/HealthQuoteApi';

import { routeHealthQuoteResultPage, HealthQuoteResultPageParams } from './route';

export const useHealthQuotesResultPageParams = () =>
  useParseParams<HealthQuoteResultPageParams>(getAllHealthQuoteParamsSchema);

type InsurancePage = {
  current: { name: string; to: string; homePath: string };
  others?: { name: string; to: string; homePath: string }[];
};

export const useInsurancePage = (): InsurancePage => {
  const { pathname } = useLocation();
  const params = useHealthQuotesResultPageParams();

  const toPath = (path: { pathname: string; search: string }) => `${path.pathname}?${path.search}`;

  const healthPage = {
    name: tInsuranceTypeName(InsuranceTypes.Health),
    to: toPath(routeHealthQuoteResultPage(params)),
    homePath: '/health-insurance-quote/members',
  };
  const personalAccidentPage = {
    name: tInsuranceTypeName(InsuranceTypes.PersonalAccident),
    to: toPath(routePersonalAccidentQuoteResultPage(params)),
    homePath: '/personal-accident-insurance-quote/members',
  };
  const cancerPage = {
    name: tInsuranceTypeName(InsuranceTypes.Cancer),
    to: toPath(routeCancerQuoteResultPage(params)),
    homePath: '/cancer-insurance-quote/members',
  };

  if (matchPath('/health-insurance-quote-results/*', pathname)) {
    return { current: healthPage, others: [personalAccidentPage, cancerPage] };
  } else if (matchPath('/personal-accident-insurance-quote-results/*', pathname)) {
    return { current: personalAccidentPage, others: [healthPage, cancerPage] };
  } else if (matchPath('/cancer-insurance-quote-results/*', pathname)) {
    return { current: cancerPage, others: [healthPage, personalAccidentPage] };
  } else {
    return { current: { name: '', to: '', homePath: '' }, others: [] };
  }
};
